
import React, { useState } from "react";
import { PlanCard } from "./PlanCard";
import { Plan } from "@/types/subscription";
import { ExtendedOrganization } from "@/hooks/organization-settings/types";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { PricingToggle } from "@/components/pricing/PricingToggle";

interface PlansListProps {
  plans: Plan[];
  organization: ExtendedOrganization | null;
  onChangePlan: () => void;
  error: string | null;
}

export const PlansList: React.FC<PlansListProps> = ({ 
  plans, 
  organization, 
  onChangePlan,
  error
}) => {
  const [isYearly, setIsYearly] = useState(false);
  
  console.log("PlansList - plans:", plans);
  console.log("PlansList - organization:", organization);
  console.log("PlansList - error:", error);
  
  if (error) {
    return (
      <Alert variant="destructive" className="my-4">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{error}</AlertDescription>
      </Alert>
    );
  }
  
  if (!plans || plans.length === 0) {
    return (
      <div className="text-center p-6 bg-white dark:bg-gray-800/60 rounded-xl shadow border border-gray-100 dark:border-gray-700/50">
        <p className="text-gray-500 dark:text-gray-400">Aucun plan d'abonnement disponible</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6 flex justify-center">
        <PricingToggle isYearly={isYearly} setIsYearly={setIsYearly} />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {plans.map((plan) => (
          <PlanCard
            key={plan.id}
            plan={plan}
            organization={organization}
            onChangePlan={onChangePlan}
            isYearly={isYearly}
          />
        ))}
      </div>
    </div>
  );
};
